// extracted by mini-css-extract-plugin
module.exports = {"form-title-container":"edit_form-title-container__3JEh9","edit-activity-container":"edit_edit-activity-container__32uWm","button-row":"edit_button-row__2QYAA"};